import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { EvaluacionPlanParticipanteDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class EvaluacionPlanParticipanteService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getEvaluacionPlanParticipanteService(): Observable<BodyListResponse<EvaluacionPlanParticipanteDTO>> {
    return this.http.get<BodyListResponse<EvaluacionPlanParticipanteDTO>>(API_URL + '/api/v1/evaluacionPlanParticipante/todos');
  }

  guardarEvaluacionPlanParticipanteService(evaluacionPlanParticipanteDTO: EvaluacionPlanParticipanteDTO): Observable<BodyResponse<EvaluacionPlanParticipanteDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/evaluacionPlanParticipante', evaluacionPlanParticipanteDTO);
  }

  getEvaluacionPlanParticipantePorCodigoTipoProcesoService(codigo: string): Observable<BodyListResponse<EvaluacionPlanParticipanteDTO>> {
    return this.http.get<BodyListResponse<EvaluacionPlanParticipanteDTO>>(API_URL + '/api/v1/evaluacionPlanParticipante/proceso/' + codigo);
  }

  guardarListaEvaluacionPlanParticipanteService(evaluacionPlanParticipanteDTO: EvaluacionPlanParticipanteDTO[], codigoProyectoParticipantes: string): Observable<BodyResponse<EvaluacionPlanParticipanteDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/evaluacionPlanParticipante/guardarLista/' + codigoProyectoParticipantes, new BodyListResponse<EvaluacionPlanParticipanteDTO>(evaluacionPlanParticipanteDTO, evaluacionPlanParticipanteDTO.length));
  }


  guardarListaEvaluacionPlanParticipantePrivadoService(evaluacionPlanParticipanteDTO: EvaluacionPlanParticipanteDTO[]): Observable<BodyResponse<EvaluacionPlanParticipanteDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/evaluacionPlanParticipante/guardarLista/', new BodyListResponse<EvaluacionPlanParticipanteDTO>(evaluacionPlanParticipanteDTO, evaluacionPlanParticipanteDTO.length));
  }


}
